import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  NgbModal,
  NgbTypeaheadSelectItemEvent,
} from "@ng-bootstrap/ng-bootstrap";
import { OperatorFunction } from "rxjs/interfaces";
import { Observable } from "rxjs/Observable";
import { debounceTime, distinctUntilChanged, mergeMap } from "rxjs/operators";

import { fromPromise } from "rxjs/observable/fromPromise";
import { TranslationService } from "../../../../_services/translation.service";
import { ITranslations } from "../../../../_models/ITranslations";
import { DiscountManagementService } from "../../../../_services/discount-management.service";
import { ChildAbstractModel } from "../../../../_models/child-abstract-model";

@Component({
  selector: "discount-management-search-child",
  templateUrl: "./discount-management-search-child.component.html",
  styleUrls: ["discount-management-search-child.component.scss"],
})
export class DiscountManagementSearchChildComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild("resultTemplate") public resultTemplate;
  @ViewChild("autoCompleteInput") public autoCompleteInput: ElementRef;
  public translations$: Observable<ITranslations>;
  @Output("childSelected")
  public childSelectedEvent: EventEmitter<ChildAbstractModel | null> = new EventEmitter<ChildAbstractModel | null>();
  public selectedChild: ChildAbstractModel;

  constructor(
    private modalService: NgbModal,
    private discountManagementService: DiscountManagementService,
    private translationService: TranslationService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public ngOnInit(): void {}

  public searchHandler: OperatorFunction<string, any> = (
    text$: Observable<any>
  ) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      mergeMap((term): any => {
        return fromPromise(
          this.discountManagementService.searchChildByText(term)
        );
      })
    );

  public formatter = (x: { name: string }) => x.name;

  public ngAfterViewInit() {}

  public ngOnDestroy(): void {}

  public getResultTemplate() {
    return this.resultTemplate;
  }

  public childSelected($event: NgbTypeaheadSelectItemEvent) {
    $event.preventDefault();
    const childSelected = $event.item as ChildAbstractModel;
    this.selectedChild = childSelected;
    this.childSelectedEvent.emit(childSelected);
  }

  public disableClick($event, stop: boolean) {
    if (!stop) {
      return;
    }
    $event.stopPropagation();
    $event.stopImmediatePropagation();
  }

  public cancelSelectedChild() {
    this.selectedChild = null;
    this.childSelectedEvent.emit(null);
    this.autoCompleteInput.nativeElement.value = "";
  }
  public searchBoxKeyDown($event: KeyboardEvent) {
    if (!this.selectedChild) {
      return;
    }
    if ($event.key === "Backspace" || $event.key === "Delete") {
      this.cancelSelectedChild();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/discounts/discount-management-page/discount-management-search-child/discount-management-search-child.component.ts